module.exports = "/assets/f3eadded9617c9ba29950a31a4531fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VF.png
// module id = 1924
// module chunks = 0